import GenericBenchmark from "./GenericBenchmark";
class Spread {
    benchmark;
    value;
    constructor(response) {
        this.benchmark = response.benchmark !== undefined ? new GenericBenchmark(response.benchmark) : undefined;
        this.value = response.value;
    }
    print() {
        const items = [];
        if (this.benchmark !== undefined)
            items.push(this.benchmark.print() ?? '');
        if (this.value !== undefined)
            items.push((this.value > 0 ? '+' : '') + this.value.toString());
        return items;
    }
}
export default Spread;
